import React, { useState, /*useRef,*/ useEffect /*, useCallback*/ } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField
} from '@mui/material';
import DateTimePicker from '@mui/lab/DateTimePicker';

import { selectUid/*, selectToken*/ } from '../login/LoginSlice';
//import { selectPrjId, selectPrjName, selectAwsId } from '../login/SummarySlice';
import { selectPrj } from '../summary/SummarySlice';

import { getAlarmsDataAsync, selectAlarmsData } from './AlarmSlice';

import styles from './Alarm.module.css';

//import { userSelectors }  from '../../state/ducks/user';
//import { summarySelectors, summaryOperations } from '../../state/ducks/summaries';

// const Item = (props) => {
//     const { sx, ...other } = props;
//     return <Box sx={{ ...sx }} {...other} />;
// };

const AlarmIcon = ({status}) => {
    switch (status) {
        case 'ok':
            return (<i className="material-icons icon-green">check_circle</i>);
        case 'ng':
            return (<i className="material-icons icon-red">error</i>);
        case 'warn':
            return (<i className="material-icons icon-yellow">warning</i>);
        default:
            return (<i className="material-icons icon-gray">help</i>);
    }
};

const AlarmListTableRows = ({alarmsData, alarmIds}) => {
    const rows = alarmIds.map((id, index) => {
        const alarm = alarmsData.alarms[id];
        
        return (<TableRow>
            <TableCell>
                <AlarmIcon status={alarm.status}/>
            </TableCell>
            <TableCell>{alarm.name}</TableCell>
            <TableCell>{alarm.metric}</TableCell>
            <TableCell>{alarm.threshold}</TableCell>
            <TableCell>{alarm.dimension}</TableCell>
        </TableRow>);
  });
  return rows;
}

const AlarmTableByNM = ({ alarmsData, namespace }) => {
    
    const alarmIds = alarmsData.map[namespace];
    
    return (
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell colSpan={5}>
              <Typography>{namespace}</Typography>
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell>Status</TableCell>
            <TableCell>Alarm Name</TableCell>
            <TableCell>Metric</TableCell>
            <TableCell>Threshold</TableCell>
            <TableCell>Dimension</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <AlarmListTableRows alarmsData={alarmsData} alarmIds={alarmIds}/>
        </TableBody>
      </Table>
    );
  };

const AlarmTables = ({alarmsData}) => {
    const namespaces = alarmsData.namespaces;
    const tables = namespaces.map((namespace,index) => {
        return (<AlarmTableByNM alarmsData={alarmsData} namespace={namespace}/>);
    });

    return (
      <TableContainer component={Paper} sx={{ width: "100%" }}>
        {tables}
        <AlarmTableByNM namespace={"Test"} list={[]} />
      </TableContainer>
    );

};

const AlarmList = ({ ...props }) => {
    const dispatch = useDispatch();

    const uid = useSelector(selectUid);
    //const token = useSelector(selectToken);

    //const prjId = useSelector(selectPrjId);
    //const prjName = useSelector(selectPrjName);
    //const awsId = useSelector(selectAwsId);
    const prj = useSelector(selectPrj);

    const alarmsData = useSelector(selectAlarmsData);
    const [targetDt, setTargetDt] = useState(new Date());

    //const handleClick = (prj, page, e) => {
    //};

    const loadItems = () => {
    //const loadItems = useCallback(() => {
        dispatch(getAlarmsDataAsync({ /*token: token,*/ uid: uid, prjId:prj.prjId, targetDt:targetDt }));
    };
    //}, []);

    useEffect(() => {
        loadItems(); 

        const interval = setInterval(() => {
            loadItems(); 
        }, 60000);
        return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <DateTimePicker renderInput={(params) => <TextField {...params} />}
                onChange={(newDt)=>{setTargetDt(newDt);} }
                value={targetDt} maxDateTime={new Date()} ampm={false} />
            <AlarmTables alarmsData={alarmsData}/>
        </div>
    );
};

export default AlarmList;
